module.exports = ".btn-chico-zone {\n    color: #ffffff;\n    background-color: #47b8e0;\n    padding: 9px 12px;\n    -webkit-transition: 0.2s all ease-in-out;\n    transition: 0.2s all ease-in-out;\n    margin-bottom: 0;\n  }\n\n.btn-chico-zone:active,\n.btn-chico-zone:hover\n{\n  background-color: #47b8e0 !important;\n  color: #ffffff !important;\n}\n\n.slidecontainer {\n  width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bus/bus-add/bus-add.component.css
// module id = ./src/app/components/bus/bus-add/bus-add.component.css
// module chunks = main